import {
  apiClient,
  handleResponse,
} from './axios';

function getRandomFunFact(userId) {
  return apiClient.get(`/funfact/random/${userId}`)
    .then(handleResponse);
}

const funFactServices = {
  getRandomFunFact,
};

export default funFactServices;
